module.exports = __webpack_public_path__ + "img/default-coin.6ba36ae2.png";